// extracted by mini-css-extract-plugin
module.exports = {"field-supporting-text":"FieldSupportingText_field-supporting-text__xXKbM"};